/**
 * Application constants for Worthly
 */

/**
 * Theme color configurations for charts (Recharts can't use CSS variables directly)
 */
export const THEME_COLORS = {
  pink: {
    primary: '#e879a0',
    light: '#fce7f3',
    lighter: '#FAF5FB',
    dark: '#db2777'
  },
  blue: {
    primary: '#6366f1',
    light: '#e0e7ff',
    lighter: '#F5F7FF',
    dark: '#4f46e5'
  },
  warm: {
    primary: '#2D5A3D',
    light: '#D8E8DC',
    lighter: '#F8F3EB',
    dark: '#1B4027'
  }
};

/**
 * Default sinking funds for new users
 */
export const DEFAULT_SINKING_FUNDS = [
  { id: 'general', name: 'General Savings Fund', emoji: '💵', goal: 0, current_by_month: {} },
  { id: 'car_maintenance', name: 'Car Maintenance Fund', emoji: '👩🏾‍🔧', goal: 0, current_by_month: {} },
  { id: 'gifts', name: 'Gifts Fund', emoji: '🎁', goal: 0, current_by_month: {} },
  { id: 'travel', name: 'Travel/Vacation Fund', emoji: '✈️', goal: 0, current_by_month: {} },
  { id: 'car_insurance', name: 'Car Insurance Fund', emoji: '📝', goal: 0, current_by_month: {} },
  { id: 'emergency', name: 'Emergency Fund', emoji: '🚨', goal: 0, current_by_month: {} },
];

/**
 * Default investment accounts for new users
 */
export const DEFAULT_INVESTMENT_ACCOUNTS = [
  { id: 'tfsa', name: 'TFSA', goal: 0, current_by_month: {} },
  { id: 'rrsp', name: 'RRSP', goal: 0, current_by_month: {} },
  { id: 'dcpp', name: 'DCPP', goal: 0, current_by_month: {} },
  { id: 'nreg', name: 'NREG', goal: 0, current_by_month: {} },
];
